import { createSelector } from '@reduxjs/toolkit';
import { selfSelector } from './self';

const pushErrorSelector = createSelector(selfSelector, (state) => state.error);

export default pushErrorSelector;
